function swiperSliderProduct()
  {
    var decisionVariable = true;
    if(document.querySelector('.thisMediaIsLinked'))
    {
    // autoheight is causing issue in hidden slides
     decisionVariable = false;
    }
    
    const swiper = new Swiper('.swiper.thisIsSwiperSliderNow', {
    // Optional parameters 
    loop: decisionVariable,
    autoHeight: decisionVariable,
    spaceBetween:0,
    observer:true,
    observeParents:true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preventInteractionOnTransition:true,
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },
  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
      
    }); 
  }

function mainInitializer() {
  if (window.innerWidth < 749) {
    var elementSliderInb = document.querySelector('slider-component .product__media-list.swiper-initialized');
    if (elementSliderInb) {
      elementSliderInb.swiper.disable();
      elementSliderInb.swiper.destroy();
    }
    swiperSliderProduct();

    if (document.querySelector('.thisIsSwiperSliderNow.swiper.swiper-initialized li.thisMediaIsLinked:not(.hideForVariant)')) {
      var selectorSlider = document.querySelector('.thisIsSwiperSliderNow.swiper.swiper-initialized');
      var activeSlide = document.querySelector('.thisIsSwiperSliderNow.swiper.swiper-initialized li.thisMediaIsLinked:not(.hideForVariant)');
    } else {
      var selectorSlider = document.querySelector('.thisIsSwiperSliderNow.swiper.swiper-initialized');
      var activeSlide = document.querySelector('.thisIsSwiperSliderNow.swiper.swiper-initialized li.is-active');
    }
    
    if (selectorSlider && activeSlide) {
      if (activeSlide.dataset.swiperSlideIndex) {
        selectorSlider.swiper.slideTo(activeSlide.dataset.swiperSlideIndex);
      } else {
        selectorSlider.swiper.slideTo(0);
      }
    }
  } else {
    var elementSlider = document.querySelector('slider-component .product__media-list.swiper-initialized');
    if (elementSlider) {
      elementSlider.swiper.disable();
      elementSlider.swiper.destroy();
      //window.parent.location.reload();
    }
  }
}

addEventListener("DOMContentLoaded", (event) => {
  mainInitializer();
});
window.addEventListener('shopify:section:load', (event) => {
mainInitializer();
});
window.addEventListener('resize', (event) => { 
//mainInitializer();
});

